import React from 'react';
import { Modal } from 'react-bootstrap'

class SignUpDecision extends React.PureComponent {
  render() {
    const { signUpopenModal, onclose, tutorOpenModalFunc, tutueeOpenModalFunc, openSignInModal } = this.props;
    return (
      <Modal
        size="lg"
        centered
        className="signUp-modal"
        show={signUpopenModal} 
        onHide={onclose}>

        <div className="text-center"
          style={{
          width:"100%",
          borderBottom:"0.3px solid lightgray",
          margin:"0px",
          paddingTop:"20px",
          paddingBottom:"20px",
          }}
          >
          <span 
          style={{
          width:"100%",
          fontFamily: "CircularStdMedium, Arial, sans-serif",
          fontSize:"16px",
          fontWeight:"bold",
          color:"black",
          textAlign:"center",
          fontStretch: "normal",
          fontStyle: "normal",
          letterSpacing: "normal",
          }}
          >
          Sign up
          </span>
        </div>
        <button
          onClick={onclose}
          type="button"
          data-dismiss="modal"
          aria-label="Close"
          style={{
          position: "absolute",
          zIndex: "9999",
          top:"15px",
          right:"50px",  
          width:"30px",
          height:"32px",
          paddingBottom:"15px",
          border:"none",
          backgroundColor:"white"
          }}
          >
          <span 
          aria-hidden="true" 
          style={{
          fontWeight:"bold",
          fontStrech:"normal",
          fontSize:"20px",
          color:"black",
          lineHeight:"normal",
          backgroundColor:"white"
          }}
          >
          x
          </span>
        </button>
        
        <Modal.Body style={{padding:"35px",marginBottom:"-25px"}}>
          <div className="container">
            <div className="row">
              <div className="col">
                <div>
                  <button 
                    className="btn-lg-block button-white mb-4" 
                    onClick={tutorOpenModalFunc} 
                    type="button"
                    style={{ 
                    height: "57px",
                    padding: "15px",
                    cursor: "pointer",
                    borderRadius: "4px",
                    border: "solid 2px rgba(112, 112, 112, 0.39)",
                    }}>
                    <span
                    style={{
                    fontFamily: "CircularStdMedium, Arial, sans-serif",
                    fontSize: "16px",
                    fontWeight: "bold",
                    fontStretch: "normal",
                    fontStyle: "normal",
                    lineHeight: "1.25",
                    letterSpacing: "0.08px",
                    textAlign: "left",
                    color: "#0f0f0f",
                    }}
                    >
                    I am a tutor
                    </span>
                  </button>
                  <div className="row mb-4">
                    <div className="col-5">
                      <hr style={{border:"none",borderBottom:"0.1px solid gray",borderRadius: "10px",boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)"}} />
                    </div>
                    <div className="col-2 text-center">or</div>
                    <div className="col-5">
                      <hr style={{border:"none",borderBottom:"0.1px solid gray",borderRadius: "10px",boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)"}} />
                    </div>
                  </div>
                  <button 
                    className="btn-lg-block login-btn mb-3" 
                    onClick={tutueeOpenModalFunc} 
                    type="button"
                    style={{ 
                    height: "57px",
                    padding: "15px",
                    cursor: "pointer",
                    fontWeight: "normal" 
                    }}>
                    <span 
                    style={{
                    fontFamily: "CircularStdMedium, Arial, sans-serif",
                    fontSize: "16px",
                    fontWeight: "bold",
                    fontStretch: "normal",
                    fontStyle: "normal",
                    lineHeight: "1.25",
                    letterSpacing: "0.08px",
                    textAlign: "left",
                    color: "#ffffff",
                    }}
                    >
                    I am parent or tutee
                    </span>
                  </button>
                  <div className="row mb-4">
                    <div className="col-lg-12">
                      <hr style={{border:"none",borderBottom:"0.1px solid gray",borderRadius: "10px",boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)"}} />
                    </div>
                  </div>
                  <div style={{marginTop:"-15px"}}>
                    <p 
                    style={{
                    width: "100%",
                    fontFamily: "OpenSans, Arial, sans-serif",
                    fontSize: "14px",
                    fontWeight: "normal",
                    fontStretch: "normal",
                    fontStyle: "normal",
                    letterSpacing: "normal",
                    textAlign: "left",
                    color: "#535252",
                    }}   
                    >Already have an Askademia account? <button
                    type="button"
                    style={{
                    fontWeight: "600",
                    color: "#0f0f0f",
                    textDecoration: "underline",
                    border:"none",
                    padding:"0px",
                    backgroundColor:"white"
                    }}
                    onClick={openSignInModal} 
                    href="#">Log in</button></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>    
    );
  }
}

export default SignUpDecision;